import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import LookCanvasContext from "../../../lookCanvasContext";
import {zoomCanvasOut} from "../../lookFunctions";
import {setCanvasScale} from "../../../../../actions/actionFunctions";
import {getLookIdUrl} from "../../lookFunctions2";
import LookMainHeaderCloseButton from "../lookMainHeaderCloseButton";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import LookViewTypeSwitcher from "../lookViewTypeSwitcher";
import Button from "@mui/material/Button";
import {setWizardActiveStep} from "../../../../../actions/wizardFunctions";

const LookWizardHeader = (props) => {

  const {intl, history, isMobile, setCanvasScale, setWizardActiveStep, wizardActiveItem} = props;

  const backButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMenuHeaderBack);
    zoomCanvasOut(imageCanvas, setCanvasScale);
    history.push(getLookIdUrl());
  };

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <Fragment>
          <div className="lm-header__back">
            <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                        className={"look-icon look-icon--small" + (isMobile ? "" : " look-icon--white")}
                        onClick={() => backButtonClick(imageCanvas)}>
              <ChevronLeftIcon/>
            </IconButton>
            <span className="lm-header__title" onClick={() => backButtonClick(imageCanvas)}>
              <FormattedMessage id="wizard.header.categories"/>
            </span>
          </div>
          <div className="lm-header__buttons">
            {isMobile && wizardActiveItem ? (
              <Button className={"look-button look-button--primary look-button--no-radius lm-header__buttons-full-button"}
                      onClick={() => setWizardActiveStep(0)}>
                <FormattedMessage id="iconButton.edit"/> {wizardActiveItem.name}
              </Button>
            ) : (
              <Fragment>
                <LookViewTypeSwitcher/>
                <LookMainHeaderCloseButton/>
              </Fragment>
            )}
          </div>
        </Fragment>
      )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {wizardActiveItem} = store.wizardState;
  return {
    isMobile,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
  setCanvasScale,
  setWizardActiveStep,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookWizardHeader)
  )
)
